<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>

<template>
  <div class="relative w-full h-screen flex items-center justify-center">
    <!-- Image as the background with <img> tag -->
    <img
      src="@/../img/home/medical-checkup.jpg"
      alt="Background"
      class="absolute inset-0 w-full h-full object-cover rounded-lg shadow-lg"
    />
    <div class="absolute inset-0 bg-white bg-opacity-80"></div>
    <div class="section-container px-4 md:px-8 py-4 md:py-8 relative z-10">
      <!-- Title -->
      <h2
        class="text-2xl md:text-3xl text-center text-black font-bold"
      >{{ $t('Ons Uniek Aanbod: Specialisatie in 24-uurs Zorg') }}</h2>

      <!-- Step Process -->
      <div class="mt-8 flex flex-col md:flex-row justify-center items-center">
        <div class="relative flex flex-wrap justify-center w-full">
          <!-- Horizontal Line -->
          <div class="absolute top-6 left-0 w-full h-1 bg-gray-300"></div>

          <!-- Step 1 -->
          <div class="w-full sm:w-1/2 md:w-1/4 text-center relative mt-4 md:mt-0">
            <div
              class="inline-flex items-center justify-center w-12 h-12 bg-[#A5C9B1] text-white text-xl font-bold rounded-md z-10"
            >1</div>
            <div class="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gray-300"></div>
            <p
              class="mt-2 text-lg"
            >{{ $t('Zorgblik is gespecialiseerd in 24-uurs zorg voor mensen met een verstandelijke beperking of psychiatrische problematiek.') }}</p>
          </div>

          <!-- Step 2 -->
          <div class="w-full sm:w-1/2 md:w-1/4 text-center relative mt-4 md:mt-0">
            <div
              class="inline-flex items-center justify-center w-12 h-12 bg-[#A5C9B1] text-white text-xl font-bold rounded-md z-10"
            >2</div>
            <div class="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gray-300"></div>
            <p
              class="mt-2 text-lg"
            >{{ $t('Zorgblik analyseert organisatorische knelpunten en werkt aan effectieve en duurzame oplossingen om een nieuwe, gewenste situatie te creëren.') }}</p>
          </div>

          <!-- Step 3 -->
          <div class="w-full sm:w-1/2 md:w-1/4 text-center relative mt-4 md:mt-0">
            <div
              class="inline-flex items-center justify-center w-12 h-12 bg-[#A5C9B1] text-white text-xl font-bold rounded-md z-10"
            >3</div>
            <div class="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gray-300"></div>
            <p
              class="mt-2 text-lg"
            >{{ $t('Onze hooggekwalificeerde professionals zijn ervaren en gecertificeerd, leveren kwaliteit, zowel individueel als in teamverband, en dragen bij aan betere zorg, gezonde werkplekken en veilige leefomgevingen.') }}</p>
          </div>

          <!-- Step 4 -->
          <div class="w-full sm:w-1/2 md:w-1/4 text-center relative mt-4 md:mt-0">
            <div
              class="inline-flex items-center justify-center w-12 h-12 bg-[#A5C9B1] text-white text-xl font-bold rounded-md z-10"
            >4</div>
            <div class="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gray-300"></div>
            <p
              class="mt-2 text-lg"
            >{{ $t('Met scholing, coaching en samenwerking met onderwijs- en zorginstellingen stimuleren we nieuw talent en versterken we de kennis en deskundigheid van zorgprofessionals.') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

